import { findEntityFieldsBySysId } from '@r/contentful-selectors'
import { Contentful } from '@t/contentful'
import { productDeepMerge } from './deep-merge-product-tables'

export type ComposedJsonEntity<T> = Contentful.TypedModule<ComposedJsonComp<T>>
export interface ComposedJsonComp<T> {
  content: Contentful.LinkedEntry[]
  // This doesn't exist in contentful and is added procedurally
  data: T
}

export interface JsonObject<T> {
  data: T
}

export interface LinkedJsonEntry {}

/** Processes a composed json component, merging all its content into one object from top to bottom */
export function processComposedJson<T>(
  state: any,
  composedJson: Contentful.TypedModule<ComposedJsonComp<T>>,
): Contentful.TypedModule<ComposedJsonComp<T>> {
  // We're merging all the linked entries into one json object stored in the `data` prop
  composedJson.fields.data = composedJson.fields.content.reduce(
    (finalObject: T | undefined, currentObject: Contentful.LinkedEntry) => {
      // The linked entity is a `jsonObject` entry in which the object is in the `data` prop
      const linkId = currentObject.sys.id
      const fields = findEntityFieldsBySysId<JsonObject<T>>(state, linkId)
      return productDeepMerge(finalObject, fields.data)
    },
    undefined,
  ) as T
  return composedJson
}
